module.exports = __webpack_public_path__ + "img/open12.59158b87.png";